import React from 'react'

import { getPlatformName } from '$extensionSrc/data/platform/name'
import BlueskyHasError from '$extensionSrc/icons/platform-logo-bluesky-has-error.svg'
import FacebookHasError from '$extensionSrc/icons/platform-logo-facebook-has-error.svg'
import GoogleHasError from '$extensionSrc/icons/platform-logo-google-has-error.svg'
import InstagramHasError from '$extensionSrc/icons/platform-logo-instagram-has-error.svg'
import LinkedInHasError from '$extensionSrc/icons/platform-logo-linkedin-has-error.svg'
import RedditHasError from '$extensionSrc/icons/platform-logo-reddit-has-error.svg'
import SnapchatHasError from '$extensionSrc/icons/platform-logo-snapchat-has-error.svg'
import StravaHasError from '$extensionSrc/icons/platform-logo-strava-has-error.svg'
import TikTokHasError from '$extensionSrc/icons/platform-logo-tiktok-has-error.svg'
import VenmoHasError from '$extensionSrc/icons/platform-logo-venmo-has-error.svg'
import XHasError from '$extensionSrc/icons/platform-logo-x-has-error.svg'
import YoutubeHasError from '$extensionSrc/icons/platform-logo-youtube-has-error.svg'
import { PLATFORM } from '$extensionSrc/utils/enums'

import styles from './PlatformErrorBanner.module.scss'

export default function PlatformErrorBanner({
  platform,
  message,
}: {
  platform: PLATFORM
  message: string
}) {
  const ErrorIcon = {
    [PLATFORM.INSTAGRAM]: InstagramHasError,
    [PLATFORM.FACEBOOK]: FacebookHasError,
    [PLATFORM.TWITTER]: XHasError,
    [PLATFORM.TIKTOK]: TikTokHasError,
    [PLATFORM.SNAPCHAT]: SnapchatHasError,
    [PLATFORM.LINKEDIN]: LinkedInHasError,
    [PLATFORM.BLUESKY]: BlueskyHasError,
    [PLATFORM.REDDIT]: RedditHasError,
    [PLATFORM.VENMO]: VenmoHasError,
    [PLATFORM.STRAVA]: StravaHasError,
    [PLATFORM.YOUTUBE]: YoutubeHasError,
    [PLATFORM.GOOGLE]: GoogleHasError,
  }[platform]

  return (
    <div className="PlatformErrorBanner">
      <div className={styles.bannerText}>
        <span className="heading3 bold">
          {getPlatformName(platform)} error detected
        </span>
        <span className="body2">{message}</span>
      </div>
      <ErrorIcon className={styles.icon} aria-hidden />
    </div>
  )
}
